import React from 'react';
/**
 * DjaySpecimen — "this is the REWARD". Renders Djay as a specific collectible's look,
 * NOT the learner's selected look.
 *
 * The `look` prop is REQUIRED and explicit, which makes it self-documenting in the
 * code that this surface is intentionally a specimen (a mirror would use <DjayIdentity>).
 * This is why achievement cards can stay "orange" while the rest of the app turns red:
 * it is deliberate, and now visibly so.
 *
 * Use this for: achievement cards, achievement illustrations, GhostTrophy,
 * CollectibleCheckpoint, AchievementUnlockModal.
 *
 * See docs/audits/MASCOT_SSOT_ARCHITECTURE_AUDIT_2026.md §5.2 (intent B).
 */
import { DjayAvatar } from './DjayAvatar';
import type { DjayAvatarProps, DjayVariant, DjayAccessory, DjayTier, DjayTreatment } from './DjayAvatar';
export interface DjaySpecimenLook {
  variant: DjayVariant;
  accessory?: DjayAccessory;
  tier?: DjayTier;
  /** Optional rarity finish (aura/sparkle/glow/gummy) for the specimen. */
  treatment?: DjayTreatment;
}
export type DjaySpecimenProps = Omit<DjayAvatarProps, 'variant' | 'accessory' | 'tier' | 'treatment'> & {
  /** The reward look this specimen represents — explicit and required. */
  look: DjaySpecimenLook;
};
export function DjaySpecimen({
  look,
  ...display
}: DjaySpecimenProps) {
  return <DjayAvatar variant={look.variant} accessory={look.accessory} tier={look.tier} treatment={look.treatment} {...display} data-id="element-3479" />;
}